import { useEffect, useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { listFiltersService, ListTableSort, SortOrder } from "sprint-common-web";

export interface UsersListingFilters {
    page: number;
    pageSize: number;
    sortBy: string;
    sortOrder: SortOrder;
    name: string;
}

const defaultFilters: UsersListingFilters = {
    page: 1,
    pageSize: 50,
    sortBy: "username",
    sortOrder: "asc",
    name: ""
};

export const useUserListingFilters = () => {
    const filtersService = useMemo(() => listFiltersService<UsersListingFilters>(defaultFilters), []);
    const location = useLocation();
    const history = useHistory();

    const [filters, setFilters] = useState<UsersListingFilters>(() => filtersService.getSavedFilters(location.search));

    useEffect(() => {
        filtersService.saveFilters(location.pathname, history, filters);
    }, [location.pathname, history, filters]);

    const setSort = (sort: ListTableSort) => {
        setFilters(
            (prevFilters: UsersListingFilters): UsersListingFilters => ({
                ...prevFilters,
                sortBy: sort.by,
                sortOrder: sort.order,
                page: 1
            })
        );
    };

    const setPage = (page: number) => {
        setFilters((prevFilters: UsersListingFilters): UsersListingFilters => ({ ...prevFilters, page }));
    };

    const setPageSize = (pageSize: number): void => {
        setFilters((prevFilters: UsersListingFilters): UsersListingFilters => ({ ...prevFilters, pageSize, page: 1 }));
    };

    const setName = (name: string): void => {
        setFilters((prevFilters: UsersListingFilters): UsersListingFilters => ({ ...prevFilters, name, page: 1 }));
    };

    const clearFilters = (): void => {
        setFilters(defaultFilters);
    };

    return {
        filters,
        setSort,
        setPage,
        setPageSize,
        setName,
        clearFilters
    };
};
